module.exports = __webpack_public_path__ + "static/img/invoice.3eacad52.png";